<template>
  <!-- content START here -->
  <div id="content">
    <!-- container START here -->
    <div class="container">
      <!-- main-colum START here -->
      <div id="main-colum">
        <div v-for="pick in picks" :key="pick.id" class="post">
          <h3>{{ pick.title }}'</h3>
          <div class="meta">
            <span class="date">{{ pick.date }}</span>
          </div>
          <p>{{ pick.content }}</p>
          <b>{{ pick.pick }}</b>
          &nbsp; &nbsp;
          <b>{{ pick.side }}</b>
          &nbsp; &nbsp;
          <b>{{ pick.price }}</b>
          &nbsp; &nbsp;
          <b>{{ pick.units }}</b>
          &nbsp;
          <b>units</b>
          <br />
          <router-link
            :to="{ path: '/admin/pick/' + pick.id }"
            class="big-btn red"
          >
            Edit Pick
          </router-link>
          <a class="big-btn red" @click.prevent="remove(pick)">Delete Pick</a>
        </div>
      </div>
      <!-- main-colum END here -->
    </div>
    <!-- container END here -->
  </div>
  <!-- content END here -->
</template>

<script>
import PickRepository from "../../data/pick.repository";
import _ from "lodash";
export default {
  data() {
    return {
      picks: [],
    };
  },
  created() {
    PickRepository.getAll().then((picks) => {
      console.log(picks);
      this.picks = picks;
    });
  },
  methods: {
    remove(pick) {
      PickRepository.remove(pick).then(() => {
        this.$root.$refs.toastr.s("Pick removed");
        _.remove(this.picks, pick);
      });
    },
  },
};
</script>

<style lang="css" scoped></style>



// WEBPACK FOOTER //
// ManagePicks.vue?c59bf73c